import { ColoresService } from './../../core/services/utils/colores.service';
import { ImagesService } from './../../core/services/utils/images.service';
import { ServicesService } from './../../core/services/http/services.service';
import { ModalPreguntaComponent } from './components/modal-pregunta/modal-pregunta.component';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { EmitService } from './../../core/services/utils/emit.service';
import { Subscription } from 'rxjs';
import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
// Services
import { AuthService } from './../../core/services/auth/auth.service';
import { OficinasService } from '../../core/services/http/oficinas.service';
import { SweetAlertService } from './../../core/services/utils/sweet-alert.service';
import { LocalService } from './../../core/services/storage/local.service';
import { CookieService } from 'ngx-cookie-service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CustomTabletPortrait } from 'src/app/core/utils/utils';
import { AesService } from 'src/app/core/services/utils/aes.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  oficinas: any;
  loginForm!: FormGroup;
  isSubmitted = false;
  isTabletPortrait = false;
  isTabletLandscape = false;
  isHandSetPortrait = false;
  isHandSetLandscape = false;
  dataLogin = {};
  resp: any;
  respno: any;
  customer: any;
  suscription!: Subscription;
  responsiveSubscription!: Subscription;
  resultadoCierre: any;
  logo: any;
  ofiSelec = new FormControl('', [Validators.required]);


  constructor(
    private renderer: Renderer2,
    private oficinasService: OficinasService,
    private formBuilder: FormBuilder,
    private router: Router,
    private aesService: AesService,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private localSecureService: LocalService,
    private emit: EmitService,
    private servicios: ServicesService,
    private modalService: ModalService,
    private imagenes: ImagesService,
    private cookieService: CookieService,
    private colores: ColoresService,
    private config: NgSelectConfig,
    private responsive: BreakpointObserver
  ) {
    this.config.notFoundText = 'No se encotraron registros';
  }

  ngOnInit(): void {
    this.localSecureService.setValue('login', false);
    this.localSecureService.removeItem('confirmar');
    this.localSecureService.removeItem('escritorio');
    this.localSecureService.removeItem('tllamado');
    this.localSecureService.removeItem('turno');
    this.renderer.addClass(document.body, 'background-login');
    this.renderer.removeClass(document.body, 'background-consultora');
    this.customer = this.localSecureService.getValue('customer');
    this.obtenerLogo(this.customer.slug);
    this.colores.estilos(this.localSecureService.getValue('valores'));
    this.obtieneData();
    this.getOficinas();
    this.setForm();
    this.responsiveSubscription = this.responsive.observe([Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,Breakpoints.WebPortrait, CustomTabletPortrait,Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape]).subscribe(
      (result:any)=>{
        const breakpoints = result.breakpoints;
        this.isTabletPortrait=false;
        this.isTabletLandscape=false;
        this.isHandSetPortrait=false;
        this.isHandSetLandscape=false;
        if (breakpoints[Breakpoints.TabletPortrait]) {
          this.isTabletPortrait=true;
        }
        else if (breakpoints[Breakpoints.TabletLandscape]) {
          this.isTabletLandscape=true;
        } else if(this.responsive.isMatched(CustomTabletPortrait)){
          this.isTabletPortrait=true;
        } else if(breakpoints[Breakpoints.HandsetPortrait]){
          this.isHandSetPortrait=true;
        } else if(breakpoints[Breakpoints.HandsetLandscape]){
          this.isHandSetLandscape=true;
        }
      }
    )
  }

  ngOnDestroy() {
    this.suscription.unsubscribe();
    this.responsiveSubscription.unsubscribe();
  }

  async obtenerLogo(slug: string) {
    this.logo = await this.imagenes.getLogo(slug);
  }


  get formControls() {
    return this.loginForm.controls;
  }

  async getOficinas() {
    const oficinas: any = await this.oficinasService.getOficinas();
    this.oficinas = oficinas.sort((a: any, b: any) => {
        if (a.oficina == b.oficina) {
          return 0;
        }
        if (a.oficina < b.oficina) {
          return -1;
        }
        return 1;
      });
    this.cargarCookies();

  }

  setForm() {
    this.loginForm = this.formBuilder.group({
      //oficina: [null, [Validators.required]],
      idEscritorio: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]\d*$/)
      ]],
      usuario: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-ZÁÉÍÓÚñáéíóúÑ0-9]*$/)
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(1)
      ]],
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.loginForm.invalid  || this.ofiSelec.invalid) {
      return;
    }
    this.ingresar();
  }

  async ingresar(){
    
    this.sweetAlertService.swalLoading();
    this.dataLogin = {
      "idOficina": this.ofiSelec.value,
      "idEscritorio": parseInt(this.loginForm.value.idEscritorio),
      "usuario": this.loginForm.value.usuario,
      "password": this.loginForm.value.password
    }

    //si el cliente es banco de chile, debo ejecutar un login
    this.resp = this.customer.slug === 'ttp_bchile' 
    ? await this.authService.loginCl(this.dataLogin)
    : await this.authService.login(this.dataLogin);

    if(((!this.resp.status || this.resp.code != 200) && this.customer.slug === 'ttp_bchile') || 
       (!this.resp.info && this.customer.slug !== 'ttp_bchile')) {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swal500();
      return;
    }

    this.resp = this.customer.slug === 'ttp_bchile' ? this.aesService.aesDecrypt(this.resp.data) : this.resp;
    if (this.resp.info) {
      switch (this.resp.listalogin[0].coderror) {
        case 0:
          this.autenticar();
          break;
        case 11521:
          this.sweetAlertService.swalClose();
          this.mostrarModalPregunta();
          break;
        default:
          this.sweetAlertService.swalClose();
          this.errorAutenticación();
          break;
      }
    } else {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swal500();
    }
  }

  autenticar() {
    this.localSecureService.setValue('login', true);
    this.localSecureService.setValue('dataLogin', this.dataLogin);
    const res = this.oficinas.find( (oficina: any) => oficina.idoficina === this.ofiSelec.value );
    const escritorio = {
      idOficina: res.idoficina,
      oficina: res.oficina,
      idEscritorio: parseInt(this.loginForm.value.idEscritorio),
      ejecutivo: this.resp.listalogin[0].ejecutivo,
      estado: this.resp.listalogin[0].estado,
      idEjecutivo: this.resp.listalogin[0].idEjecutivo
    }
    this.localSecureService.setValue('escritorio', escritorio);
    this.router.navigate([this.customer.slug, 'llamados']);
    this.sweetAlertService.swalClose();
  }

  mostrarModalPregunta(): void {
    const opciones = { class: '', initialState: {} };
    this.modalService.openModal(ModalPreguntaComponent, opciones);
  }

  errorAutenticación() {
    this.sweetAlertService.swalClose();
    this.sweetAlertService.swalErrorLogin(
      '¡Lo sentimos!',
      'Ha ocurrido un error de autenticación',
      this.resp.listalogin[0].msg);
  }

  obtieneData() {
    this.suscription = this.emit.loguear.subscribe((data: any) => {
      if (data == 'confirmar') {
        this.sweetAlertService.swalLoading();
        this.desloguear();
      }
    });
  }

  async desloguear(){
    const dataCierre ={
      "idOficina": this.ofiSelec.value,
      "idEscritorio": parseInt(this.loginForm.value.idEscritorio)
    }
    await this.servicios.logOff(dataCierre).then((data) => {
      this.resultadoCierre = data;
    });
    if (this.resultadoCierre.info.coderr == 0) {
      this.ingresar();
    } else {
      this.sweetAlertService.swalClose();
      this.sweetAlertService.swal500();
    }
  }

  selectChange() {
    let id: any = this.ofiSelec.value;
    this.cookieService.set('idOficina', id);
  }

  cargarCookies() {
    if (this.cookieService.get('idOficina')) {
      let id: any = Number(this.cookieService.get('idOficina'));
      this.ofiSelec.setValue(id);
    }
  }



}


